"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Fen_1 = __importDefault(require("chess-fen/Fen"));
var types_1 = require("chess-fen/types");
var cardinal_1 = require("../themes/pieces/cardinal");
var blue_1 = require("../themes/boards/blue");
var Board = /** @class */ (function (_super) {
    __extends(Board, _super);
    function Board(_a) {
        var fen = _a.fen, size = _a.size, _b = _a.pieceTheme, pieceTheme = _b === void 0 ? {} : _b, _c = _a.boardTheme, boardTheme = _c === void 0 ? {} : _c, _d = _a.rotated, rotated = _d === void 0 ? false : _d;
        var _this = _super.call(this, fen) || this;
        _this.size = size;
        _this.squareSize = size / _this.columns;
        _this.rotated = rotated;
        _this.coordinates = _this.createCoordinates();
        _this.pieceTheme = __assign(__assign({}, cardinal_1.cardinal), pieceTheme);
        _this.boardTheme = __assign(__assign({}, blue_1.blue), boardTheme);
        return _this;
    }
    Board.prototype.get = function (positionOrCoordinate) {
        var boardContent = _super.prototype.get.call(this, positionOrCoordinate);
        if (boardContent === null) {
            throw new Error(Board.toCoordinate(positionOrCoordinate) + " is outside the board.");
        }
        return boardContent;
    };
    Board.prototype.isCapture = function (fromPosition, toPosition) {
        var piece = this.get(fromPosition);
        var target = this.get(toPosition);
        return (target !== null && target !== types_1.BoardContent.EmptySquare) ||
            (piece.includes(types_1.Piece.Pawn) && toPosition.toCoordinate() === this.enPassantSquare);
    };
    Board.prototype.isPawnMove = function (fromPosition, toPosition) {
        var piece = this.get(fromPosition);
        var capture = this.isCapture(fromPosition, toPosition);
        var isPawnMove = function (canMakeDoubleMove) {
            var range = canMakeDoubleMove ? 2 : 1;
            return ((!capture && fromPosition.isVerticalTo(toPosition, range)) ||
                (capture && fromPosition.isDiagonalTo(toPosition, 1)));
        };
        if (this.toMove === "white" && piece === types_1.BoardContent.WhitePawn) {
            return fromPosition.isNorthTo(toPosition) && isPawnMove(fromPosition.y === this.rows - 2);
        }
        else if (this.toMove === "black" && piece === types_1.BoardContent.BlackPawn) {
            return fromPosition.isSouthTo(toPosition) && isPawnMove(fromPosition.y === 1);
        }
        return false;
    };
    ;
    Board.prototype.isPromotion = function (fromPosition, toPosition) {
        if (this.toMove === "white") {
            return this.isPawnMove(fromPosition, toPosition) && fromPosition.y === 1 && toPosition.y === 0;
        }
        return this.isPawnMove(fromPosition, toPosition) &&
            (fromPosition.y === this.rows - 2) && (toPosition.y === this.rows - 1);
    };
    ;
    Board.prototype.createCoordinates = function () {
        var coordinates = { x: [], y: [] };
        for (var x = 0; x < this.columns; x++) {
            coordinates.x.push(String.fromCharCode(x + 97));
        }
        for (var y = this.rows; y > 0; y--) {
            coordinates.y.push(y.toString());
        }
        return this.rotated ? {
            x: coordinates.x.reverse(),
            y: coordinates.y.reverse()
        } : coordinates;
    };
    ;
    Board.toCoordinate = function (positionOrCoordinate) {
        return typeof positionOrCoordinate === "string" ? positionOrCoordinate : positionOrCoordinate.toCoordinate();
    };
    return Board;
}(Fen_1.default));
exports.Board = Board;
exports.default = Board;
